import { setFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  DesignateLeadersFromOfficeGroupAsyncAction,
  DesignateLeadersFromOfficeGroupAsyncResultsRemoveAction,
  DesignateLeadersFromOfficeGroupAsyncStatusAction,
} from '../../domains/leadersManagement/actions.types';

import type {
  DesignateLeadersFromOfficeGroupAsyncResults,
  DesignateLeadersFromOfficeGroupAsyncResultsFields,
} from './types';

export type DesignateLeadersFromOfficeGroupAsyncResultsAction =
  | DesignateLeadersFromOfficeGroupAsyncAction
  | DesignateLeadersFromOfficeGroupAsyncStatusAction
  | DesignateLeadersFromOfficeGroupAsyncResultsRemoveAction;

const initialState: DesignateLeadersFromOfficeGroupAsyncResults = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const setPendingWithPreviousResults = (
  state: DesignateLeadersFromOfficeGroupAsyncResults
): DesignateLeadersFromOfficeGroupAsyncResults => ({
  pending: true,
  fulfilled: state.fulfilled,
  rejected: undefined,
});

const setFulfilledWithPreviousResults = (
  state: DesignateLeadersFromOfficeGroupAsyncResults,
  designateLeadersFromOfficeGroupAsyncNewResultsFields: DesignateLeadersFromOfficeGroupAsyncResultsFields
): DesignateLeadersFromOfficeGroupAsyncResults => ({
  pending: false,
  fulfilled: {
    ...state.fulfilled,
    ...designateLeadersFromOfficeGroupAsyncNewResultsFields,
  },
  rejected: undefined,
});

const setRejectedWithPreviousResults = (
  state: DesignateLeadersFromOfficeGroupAsyncResults,
  error: unknown
): DesignateLeadersFromOfficeGroupAsyncResults => ({
  pending: false,
  fulfilled: state.fulfilled,
  rejected: error,
});

const reducer: Reducer<
  DesignateLeadersFromOfficeGroupAsyncResults,
  DesignateLeadersFromOfficeGroupAsyncResultsAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP_ASYNC.FULFILLED':
      return setFulfilled({ ...action.payload, state: 'Active' });
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP_ASYNC_STATUS.PENDING':
      return setPendingWithPreviousResults(state);
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP_ASYNC_STATUS.FULFILLED':
      return setFulfilledWithPreviousResults(state, action.payload.results);
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP_ASYNC_STATUS.REJECTED':
      return setRejectedWithPreviousResults(state, action.payload.error);
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP_ASYNC.REMOVE_RESULTS':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
